import { mapActions, mapState } from 'vuex'
import { VueAvatar } from 'vue-avatar-editor-improved'

export default {
  components: {
    VueAvatar
  },
  data () {
    return {
      form: {
        firstName: '',
        lastName: '',
        nickName: '',
        team: '',
        city: '',
        position: '',
        infoEdition: '',
        infoChat: '',
        infoUltimate: '',
        photoUrl: ''
      },
      positions: [
        { value: 'handler', label: this.$t('register_position_handler') },
        { value: 'cutter', label: this.$t('register_position_cutter') },
        { value: 'both', label: this.$t('register_position_both') }
      ],
      required: value => !!value || this.$t('error_required'),
      imageReady: false,
      scale: 1,
      saved: false,
      shouldShowAlert: false,
      selectedFile: null,
      isSelecting: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState(['players', 'teams']),
    player () {
      return this.players[this.$route.params.playerId]
    },
    team () {
      return this.teams[this.player.assignedTeam]
    }
  },
  watch: {
    player: {
      immediate: true,
      handler: function (player) {
        if (player) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = player[key]
          })
        }
      }
    },
    saved (saved) {
      this.shouldShowAlert = saved !== null
    }
  },
  methods: {
    ...mapActions(['savePlayer']),
    save () {
      this.saved = null
      if (this.$refs.updateForm.validate()) {
        this.isLoading = true
        this.savePlayer({
          playerId: this.id,
          photoData: this.imageReady ? this.$refs.vueavatar.getImageScaled().toDataURL() : undefined,
          data: this.form
        }).then(_ => {
          this.saved = true
        }).catch(e => {
          this.saved = false
        }).finally(_ => {
          this.isLoading = false
        })
      }
    },
    onImageReady () {
      this.scale = 1
      this.imageReady = true
    }
  }
}
